import { ExternalHTTP as HTTP } from "@/src/common/data-layer"

/**
 * @deprecated Please use "import { ExternalHTTP } from @/src/common/data-layer" instead
 */
export class ExternalHTTP extends HTTP {}

/**
 * @deprecated Please use "import ExternalHTTPInstance from @/src/common/data-layer" instead
 */
const ExternalHTTPInstance = new ExternalHTTP()

export default ExternalHTTPInstance
